var _module_exports = "<span>Please <a data-ng-click=\"flashScope.openDepositModal()\">DEPOSIT YOUR FUNDS</a> now so that {{flashScope.task.contractor.fullName}} can begin working on your project!</span>\n";;
var path = 'views/flashes/deposit_money.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;